import { checkServiceAuth } from "../APICalling/ServiceAPICalling";
import {
  checkZohoAuth,
  getAllActiveUsersAndCurrentUser,
  getOrgVariable,
  setOrgId,
  setUpDataCenter,
  setUpDataCenterUrl,
  setUpOrgVariable,
} from "../APICalling/ZohoAPICalling";
import {
  API_KEY_API_NAME,
  ORG_ID_API_NAME,
  SERVICE_API_KEY_API_NAME,
  SERVICE_AUTHENTICATION_TYPE,
  SERVICE_CONN,
  ZOHO_CONN,
  Z_API_KEY_API_NAME,
} from "../config/serviceConstant";
const ZOHO = window.ZOHO;

const authCheckZoho = async ({ orgId, apiKey, dataCenterUrl }) => {
  try {
    if (!orgId || !apiKey || !dataCenterUrl) {
      return false;
    }
    const zohoHeaders = {
      orgid: orgId,
      connname: ZOHO_CONN,
      apikey: apiKey,
      datacenterurl: dataCenterUrl,
    };
    return await checkZohoAuth(zohoHeaders);
  } catch (error) {
    return false;
  }
};

const authCheckService = async ({ ZOHO, orgId, apiKey }) => {
  try {
    if (!orgId || !apiKey) {
      return false;
    }
    const serviceHeaders = {
      orgId: orgId,
      connname: SERVICE_CONN,
      apiKey: apiKey,
    };
    let serviceToken = await checkServiceAuth(serviceHeaders);
    if (SERVICE_AUTHENTICATION_TYPE == "apikey") {
      // Set apikey in variable
      await setUpOrgVariable(ZOHO, SERVICE_API_KEY_API_NAME, serviceToken);
      return true;
    }
    console.log({ test });
    return true;
  } catch (error) {
    return false;
  }
};

export async function initZoho(callback) {
  try {
    ZOHO.embeddedApp.on("PageLoad", async function () {
      let extensionData = {};

      const orgId = await getOrgVariable(ZOHO, ORG_ID_API_NAME);
      const { allUsers, currentUser } = await getAllActiveUsersAndCurrentUser(
        ZOHO
      );
      const apiKey = await getOrgVariable(ZOHO, API_KEY_API_NAME);
      const zApiKey = await getOrgVariable(ZOHO, Z_API_KEY_API_NAME);
      // const serviceApiKey = await getOrgVariable(
      //   ZOHO,
      //   SERVICE_API_KEY_API_NAME
      // );
      const dataCenterUrl = await setUpDataCenterUrl(ZOHO);
      const dataCenter = await setUpDataCenter(ZOHO);

      // extensionData["zohoAuth"] = await authCheckZoho({
      //   orgId,
      //   apiKey,
      //   dataCenterUrl,
      // });

      // extensionData["serviceAuth"] = await authCheckService({
      //   ZOHO: ZOHO,
      //   orgId,
      //   apiKey,
      // });

      extensionData["orgId"] = orgId;
      extensionData["apiKey"] = apiKey;
      extensionData["dataCenterUrl"] = dataCenterUrl;
      extensionData["dataCenter"] = dataCenter;

      extensionData["zApiKey"] = zApiKey;
      // extensionData["serviceApiKey"] = serviceApiKey;

      extensionData["zohoLoaded"] = true;
      extensionData["activeUsers"] = allUsers;
      extensionData["currentUser"] = currentUser;

      callback(null, extensionData);
    });
    ZOHO.embeddedApp.init().then(() => {});
  } catch (initZohoError) {
    console.log({ initZohoError });
    callback(initZohoError, null);
  }
}
